
import { Injectable } from "@angular/core";
import { ApiService } from "./apiService";
import { ClassMetadata, ReportCriteria, ReportReturnParms } from "@tylertech/tyler-api-types";

/**
 * StateReportingService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class StateReportingService {
    constructor(private readonly $apiService: ApiService) { }
    
    GenerateReport(pCriteria: ReportCriteria): Promise<ReportReturnParms> {
        return this.$apiService.sendAuth("IStateReportingService/GenerateReport", pCriteria);
    }
    ParameterMetadata(pCriteria: ReportCriteria): Promise<ClassMetadata> {
        return this.$apiService.sendAuth("IStateReportingService/ParameterMetadata", pCriteria);
    }
}
